@if (!isAppMobile) {
  <h1 class="dsd-b-30 dsd-color-font-secondary dsd-mb-xs">
    {{ 'validation.sousTitre' | translate }}
  </h1>
}
<h2 id="titreValidation" tabindex="-1" class="dsd-t-3 dsd-mb-md">
  {{ 'validation.titre' | translate }}
</h2>

<dsd-container>
  <h3 class="dsd-t-4">{{ 'validation.sousTitreAdresse' | translate }}</h3>
  <p>
    <span class="libelle">{{ 'validation.libelleNouvelleAdresse' | translate }}&nbsp;</span>
    <span class="valeur line-data">{{ adresseSaisie | adresse }}</span>
  </p>
  <p>
    <span class="libelle">{{ 'validation.libelleDateChangement' | translate }}&nbsp;</span>
    <span class="valeur line-data" [innerHTML]="dateDebutUtilisation | dateCustom"></span>
  </p>
  <dsd-button
    id="naviguerVersModifierAdresse"
    variant="compact"
    (dsdButtonClick)="naviguerVersModifierAdresse()"
  >
    {{ 'bouton.modifier' | translate }}&nbsp;
    <span class="dsd-sr-only">
      {{ 'horsEcran.pageValidationAdresse' | translate }}
    </span>
  </dsd-button>
</dsd-container>

<dsd-container>
  <h3 class="dsd-t-4">{{ 'validation.sousTitreAssurances' | translate }}</h3>
  @if (afficherDetention) {
    <p>
      <span class="libelle"
        >{{ 'validation.questionsDGAG.libelleDetention' | translate }}&nbsp;</span
      >
      <span class="valeur line-data">{{ 'validation.questionsDGAG.non' | translate }}</span>
    </p>
  }
  @if (afficherChangementFait) {
    <p>
      <span class="libelle"
        >{{ 'validation.questionsDGAG.libelleChangementFait' | translate }}&nbsp;
      </span>
      <span class="valeur line-data">{{ 'validation.questionsDGAG.oui' | translate }}</span>
    </p>
  }

  @if (afficherAppel) {
    <p>
      <span class="libelle"
        >{{ 'validation.questionsDGAG.libellePreferenceAppel' | translate }}&nbsp;
      </span>
      <span class="valeur line-data">{{ preferenceAppel | translate }}</span>
    </p>
  }

  @if (afficherMoment) {
    <p>
      <span class="libelle"
        >{{ 'validation.questionsDGAG.libellePreferenceMoment' | translate }}&nbsp;
      </span>
      <span class="valeur line-data">{{ preferenceMoment | translate }}</span>
    </p>
  }
  <dsd-button
    id="naviguerVersModifierAssurances"
    variant="compact"
    (dsdButtonClick)="naviguerVersModifierAssurances()"
  >
    {{ 'bouton.modifier' | translate }}&nbsp;
    <span class="dsd-sr-only">
      {{ 'horsEcran.pageValidationAssurances' | translate }}
    </span>
  </dsd-button>
</dsd-container>

<div class="zone-btn">
  <!-- Bouton Confirmer -->
  <dsd-button variant="primary" full-width="xs" (dsdButtonClick)="naviguerVersConfirmation()">
    {{ 'bouton.confirmer' | translate }}
  </dsd-button>
  <!-- Bouton Annuler -->
  <dsd-button full-width="xs" id="btnAnnuler" (dsdButtonClick)="annuler()">
    {{ 'bouton.annuler' | translate }}
  </dsd-button>
</div>
